<template>
  <u-avatar
    :size="size"
    :icon="COMMON_ICONS.tag"
    :src="tag.avatarImage"
    :ui="uiConfig"
    :img-class="imgClass"
  />
</template>

<script setup>
  import merge from 'lodash.merge';

  const props = defineProps({
    tag: Object,
    size: {
      type: String,
      default: 'md'
    },
    ui: Object,
    hoverZoom: Boolean
  });

  const rounded = computed(() => {
    switch (props.size) {
      case '2xs':
      case 'xs':
      case 'sm':
      case 'md':
        return 'rounded';
      default:
        return 'rounded-lg';
    }
  });

  const uiConfigBase = {
    background: 'bg-shell',
    icon: {base: 'text-charcoal/60 scale-125'},
    rounded: rounded.value,
    wrapper: 'overflow-hidden'
  };

  const uiConfig = merge(uiConfigBase, props.ui);

  const imgClass = computed(() => {
    return props.hoverZoom
      ? 'object-cover transition duration-300 group-hover:scale-[1.03]'
      : 'object-cover';
  });
</script>
